import { Card } from "antd";
import styles from "./styles.module.scss";

import { ReactComponent as PlusIcon } from "../../assets/plus_icon.svg";
import { ReactComponent as UserIcon } from "../../assets/user_icon.svg";
import { ReactComponent as WebIcon } from "../../assets/web_icon.svg";
import { ReactComponent as PaymentIcon } from "../../assets/payment.svg";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { routes } from "../../routes";
import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { userAtom } from "../../utils/store";

const LandingPage = () => {
  const user = useAtomValue(userAtom);

  const navigate = useNavigate();

  const handleNavigation = (route: string, href?: string) => {
    if (href) {
      window.location.href = href;
      return;
    }
    navigate(route);
  };

  useEffect(() => {
    if (user?.isNewUser) {
      navigate(routes.onboarding);
    } else if (user?.token) {
      navigate(routes.dashboard.bioData);
    }
  }, [navigate, user?.isNewUser, user?.token]);

  return (
    <section className={styles.container}>
      <div>
        <Card>
          <div className={styles.cardChild}>
            <div>
              <h3>Welcome to our portal</h3>
            </div>

            <div>
              {data.map((item, index) => (
                <motion.div key={index} whileHover={{
                  scale: 1.1,
                  rotate: 2,
                  boxShadow: "0px 4px 15px #3c5ca6"
                }}>
                  <button
                    className={styles.buttonStyle}
                    onClick={() => handleNavigation(item?.route, item?.href)}
                  >
                    <div>
                      <div>{item.icon}</div>
                      <p>{item.text}</p>
                    </div>
                  </button>
                </motion.div>
              ))}
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default LandingPage;

const data: { icon: JSX.Element; text: string; route: string; href?: string }[] = [
  { icon: <PlusIcon />, text: "New Applicant", route: routes.main.home },
  { icon: <UserIcon />, text: "Return to my Application", route: routes.auth.login },
  // { icon: <UserIcon />, text: "Returning Student", route: routes.auth.login },
  {
    icon: <PaymentIcon />,
    text: "Requery Pending Payment",
    route: routes.auth.requeryPayment,
  },
  // { icon: <WebIcon />, text: "Back to Website", route: "", href: "https://pti.edu.ng" },
];
